import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import tiposFinanciamento from "../../../constants/tiposFinanciamento";
import { UNIDADES_ATIVAS } from "../../../constants/unidades";
import utils from "../../../utils/utilsGraficos";
import SelectCampo from "../Relatorio/Grafico/SelectCampo";
import SelectModalidade from "../Relatorio/Cursos/SelectCampo";
import Chart from "react-apexcharts";
import Select from "../Relatorio/Grafico/Select";

export default class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            metas: [],
            nomeCampo: "numTurmas",
            selectCampo: 0,
            selectTipo: 3,
            modalidade: "Todas",
            unidade: "Todas",
            tipoSelecionado: "Todos",
            series: [
                {
                    name: "Pago",
                    data: []
                },
                {
                    name: "Gratuidade Regimental",
                    data: []
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: []
                }
            ],

            options: {
                chart: {
                    height: 350,
                    type: 'column',
                    // dropShadow: {
                    //     enabled: true,
                    //     color: '#000',
                    //     top: 18,
                    //     left: 7,
                    //     blur: 10,
                    //     opacity: 0.2
                    // },
                    toolbar: {
                        show: false
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false
                },
                colors: ['#77B6EA', '#545454', '#FEBC3B', '#eb8989', '#89ebb5', '#ff0000', '#007bff', '#000000'],
                dataLabels: {
                    enabled: false,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    background: {
                        enabled: true,
                        borderWidth: 1,
                    },
                },
                plotOptions: {
                    bar: {
                        columnWidth: "70%",
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                title: {
                    text: 'Total',
                    align: 'left'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                    title: {
                        text: 'Mês'
                    }
                },
                yaxis: {
                    title: {
                        text: 'TOTAL'
                    },
                    labels: {
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }

                    }
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'center',
                    offsetY: 5,
                    offsetX: 0,
                    /*
                    formatter: function(seriesName, opts) {
                        seriesName = seriesName === "Total" ? "" : seriesName;
                        return [seriesName]
                    }
                    */
                }
            }

        }
    }

    async componentDidMount() {
        await this.loadMetas();
        this.calculaTipoPorMes();
    }

    loadMetas = async () => {
        let metas = await api.get("/metasformatadas");
        this.setState({ metas: metas.data.metas });
    }

    informaCampo = (selectCampo) => {
        var propriedades = [
            "N.° de Turmas",
            "N.º de Alunos Turmas",
            "Carga Horária",
            "Mat. Residuais",
            "Mat. Novas",
            "Total Mat.",
            "Hora/aluno",
            "Carga H. Turma/Ano",
            "Necessidade de docente (8h)",
            "Necessidade de docente (7,2h)"
        ]
        return propriedades[selectCampo]
    }

    calculaTipoPorMes = (event) => {
        // Lista canônica confirmada com o usuário (2026-08-24): antes desta migração,
        // este array tinha as 11 unidades (incluindo ISTAI) mas a `series` do gráfico
        // (mais abaixo) só mostrava 8 — ISTAI/ISTTC/ISTEO eram calculadas aqui e nunca
        // chegavam a aparecer. Agora as duas listas usam a mesma fonte: ISTTC/ISTEO
        // passam a aparecer no gráfico, ISTAI continua de fora (e some também do total
        // agregado, já que nunca deveria ter entrado nessa conta pra começo de conversa).
        let unidades = UNIDADES_ATIVAS.map((u) => u.nome)

        let { metas, selectCampo, selectTipo, modalidade, unidade, tipoSelecionado } = this.state
        let tipo = tiposFinanciamento.LABELS;

        let filtros = {
            modalidade, 
            unidade,
        }

        let evento;
        if (Boolean(event)) {
            evento = event.target.value;
            let target = event.target.id;

            if (target === "selectCampo") {
                selectCampo = evento;
            }
            if (target === "selectModalidade") {
                filtros.modalidade = evento;
                modalidade = evento;
            }
            if (target === "selectTipo") {
                filtros.tipo = tipo[evento];
                selectTipo = evento !== "Todos" ? evento : 3;
                tipoSelecionado = evento !== "Todos" ? tipo[selectTipo] : "Todos" ;
            }
        }

        if (modalidade === "Todas") delete filtros.modalidade;
        if (unidade === "Todas") delete filtros.unidade;
        if (evento === "Todos" || tipoSelecionado === "Todos") {
            delete filtros.tipo;

        };

        let json = {}

        unidades.forEach((unidade, ind) => {
            filtros.unidade = unidade;
            let totalTipos = []

            let dados = tipo.map(tipo => {
                filtros.tipo = tipo;
                let meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
                let metasFiltradas = utils.filtrar(metas, filtros);
                let resultados = meses.map(mes => utils.total(metasFiltradas, mes)[selectCampo]);
                let total = resultados.reduce((acc, atual) => acc + atual, 0);
                totalTipos.push(total);
                return resultados
            });

            let t = dados[0].map((v, i) => {
                return v + dados[1][i] + dados[2][i]
            });
            dados.push(t);

            let total = totalTipos.reduce((acc, atual) => acc + atual, 0);

            json[unidade] = {
                dados,
                totalTipos,
                total
            }

        });
        
        let totalTipos = [0, 0, 0]
        Object.keys(json).map(uni => {
            totalTipos[0] += json[uni]["totalTipos"][0]
            totalTipos[1] += json[uni]["totalTipos"][1]
            totalTipos[2] += json[uni]["totalTipos"][2]
        });
        
        //Componente Pai
        this.props.totais(totalTipos)
        //===

        let selecionaTipoTotal = evento === "Todos" ? 3 : selectTipo;
        
        this.setState({
            json,
            totais: totalTipos,
            modalidade: modalidade,
            unidade: unidade,
            selectCampo: selectCampo,
            selectTipo: selectTipo,
            tipoSelecionado: tipoSelecionado,
            nomeCampo: this.informaCampo(selectCampo),
            series: unidades.map((nomeUnidade) => ({
                name: nomeUnidade,
                data: json[nomeUnidade]["dados"][selecionaTipoTotal]
            })),

        });

    }

    render() {
        return (
            <Fragment>
                
                <div className="row">
                    <div className="col-md-12">
                        <div className="card ">
                            <div className="card-header ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="card-title">{this.state.nomeCampo}</h5>
                                        <h6>{this.state.modalidade}</h6>
                                    </div>
                                    <div className="col-md-2">
                                        <form>
                                            <div className="form-group">
                                                <label>Tipo: </label>
                                                <select name="selectTipo" onChange={this.calculaTipoPorMes} className="form-control" id="selectTipo">
                                                    <option value={"Todos"}>Todas</option>
                                                    <option value={0}>Pagos</option>
                                                    <option value={1}>Gratuidade Regimental</option>
                                                    <option value={2}>Gratuidade Não-Regimental</option>
                                                </select>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-2">
                                        <SelectCampo selectCampo={this.calculaTipoPorMes} />
                                    </div>
                                    <div className="col-md-2">
                                        <SelectModalidade selectModalidade={this.calculaTipoPorMes} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="mixed-chart">
                                    <Chart options={this.state.options} series={this.state.series} type={'bar'} height={"300"} />
                                </div>
                            </div>
                            <div className="card-footer ">
                                <hr />
                                <div className="stats">
                                    <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                    <span style={{ float: 'right' }}>
                                        <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }} onClick={() => this.props.escolheDash()}>
                                            Visão Modalidades
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}